<template>
  <div class="list-component">
    <div class="columns is-multiline is-mobile" :id="fieldSet.id">
      <ul class="column is-12">
        <!-- For each list column with field inside  -->
        <li class="form-field"
          v-for="field in fieldSet.fields"
          :key="field.uid">
          <form-field-component
            :field="field"
            :formData="formData"
            :listMarker="fieldSet.layout.marker">
          </form-field-component>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import FieldSet from '@/classes/form/FormFieldSet'
  import FormData from '@/classes/form/FormData'
  import FormFieldComponent from '@/components/form/field/FormFieldComponent'

  export default {
    name: 'list-form-component',
    components: {
      FormFieldComponent
    },
    props: {
      fieldSet: {
        type: FieldSet,
        required: true
      },
      formData: {
        type: FormData
      }
    }
  }
</script>

<style lang="sass" scoped>
  .form-field
    margin-bottom: 15px
</style>
